/*
for details on Vimeo video embedding see:
https://developer.vimeo.com/api/oembed/videos
*/
import MarketingEmbedMixin from '~/themes/cvb/mixins/MarketingEmbedMixin'
import VideoMixin from '~/mixins/VideoMixin'

export default {
  mixins: [MarketingEmbedMixin, VideoMixin],
  props: {
    video: Object,
  },
  data() {
    return {
      id: `player-${Math.round(Math.random() * 10000)}`,
      iframe: '',
      isInitialized: false,
      videoProvider: '',
      ytPlayer: null,
    }
  },
  watch: {
    hasMarketingConsent(value) {
      if (value) {
        this.initPlayer()
      }
    },
  },
  methods: {
    async initPlayer() {
      if (this.isInitialized || !this.video || !this.video.video_url) {
        return
      }

      this.videoProvider = this.getVideoProvider(this.video.video_url)

      if (!this.hasMarketingConsent && this.isMarketingEmbedUrl(this.video.video_url)) {
        return
      }

      this.isInitialized = true

      if (this.videoProvider === 'vimeo') {
        const response = await this.callVimeoApi(this.video.video_url)
        this.iframe = response.data.html
      } else if (this.videoProvider === 'youtube') {
        const tag = document.createElement('script')

        tag.src = 'https://www.youtube.com/iframe_api'
        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

        window.onYouTubeIframeAPIReady = () => {
          this.ytPlayerInit()
        }

        if (window.yt) {
          this.ytPlayerInit()
        }
      }
    },
    ytPlayerInit() {
      this.ytPlayer = new YT.Player(this.id, {
        height: '780',
        width: '1280',
        videoId: this.getYouTubeVideoCode(this.video.video_url),
        events: {
          onReady: onPlayerReady,
        },
      })
      function onPlayerReady(event) {
        event.target.playVideo()
      }
    },
  },
  mounted() {
    this.initPlayer()
  },
}
